/* eslint-disable react/prop-types */
import React from "react";
import EmptyValue from "../../../components/EmptyValue";
import { EVITAL_QUOTE_BASE_URL } from "../../constants/evital";
import { salesPersonName } from "../../../utils/salesPerson";


const LINK_CLASS = "text-elm-500 underline";
const stop = (event) => event.stopPropagation();

/** The row's server-computed finance block, or {} when it was not requested. */
const finance = (row) => row?.row?.original?.finance || {};

export function buildSalesQuotationColumns() {
    return [
        {
            Header: "Discount %",
            id: "discountPercentage",
            accessor: "finance.discountPercentage",
            disableSortBy: true,
            Cell: (row) => {
                const pct = finance(row).discountPercentage;
                return pct === null || pct === undefined ? <EmptyValue /> : <span className="tabular-nums">{pct}%</span>;
            },
        },
        {
            Header: "Evital No",
            id: "evitalOrderNumber",
            accessor: "finance.evitalOrderNumber",
            disableSortBy: true,
            Cell: (row) => {
                const id = finance(row).evitalOrderNumber || row?.row?.original?.inventoryId;
                if (!id) return <EmptyValue />;
                return (
                    <a href={`${EVITAL_QUOTE_BASE_URL}${id}`} target="_blank" rel="noreferrer" onClick={stop} className={LINK_CLASS}>
                        {id}
                    </a>
                );
            },
        },
        {
            Header: "Sales Person",
            id: "salesPerson",
            accessor: "salesPerson",
            // Not sortable: salesOwnerId IS a real column on quotations, but the name
            // shown comes from MyTatva and the fallback comes from orderStatusHistory, so
            // ordering by the column would not order by what the cell displays.
            disableSortBy: true,
            // "QUOTATION", not "USER_ORDER" -- a quotation's transitions are logged
            // against its own id, so asking for USER_ORDER here would find nothing and
            // the fallback would silently never fire.
            Cell: (row) => salesPersonName(row?.row?.original, "QUOTATION") || <EmptyValue />,
        },
    ];
}

export default buildSalesQuotationColumns;
